module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.29018/images/keyFeatures/data_agent.png"